import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MyService } from '../services/myservice';
import { AuthenticationService } from '../services/authentication.service';
import { MembershipRestrictionComponent } from '../views/membership-restriction/membership-restriction.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-download',
    standalone: true,
    imports: [CommonModule, FormsModule, MembershipRestrictionComponent],
    templateUrl: './download.component.html',
    styleUrl: './download.component.scss',
})
export class DownloadComponent {
    documentId: any;
    isLoggedIn: boolean = false;
    fileUrl!: SafeResourceUrl;
    fileName: string = 'default.pdf'; // default file name
    constructor(
        private route: ActivatedRoute,
        private myservice: MyService,
        private authService: AuthenticationService,
        private sanitizer: DomSanitizer,
    ) { }

    ngOnInit(): void {
        this.checkAccess();
        this.myservice.getToken().then(token => {
            this.route.queryParamMap.subscribe((params) => {
                this.documentId = params.get('id');
                this.myservice.getFilesDownload(this.documentId, token).subscribe(res => {
                    console.log(res);
                    this.fileName = res.fileName; // assume the response contains fileName
                    const fileType = this.getFileMimeType(this.fileName);
                    this.convertBase64ToFileUrl(res.data, fileType);
                });
            });
        });
        this.myservice.setTitleAndMeta("Download File", "Download the resultant output file from a pending job.", "download, file, job", "NA");

    }

    checkAccess(): void {
        this.isLoggedIn = this.authService.isLoggedIn();
        console.log('user logged in for modal ', this.isLoggedIn);
    }


    async download() {
        this.myservice.getFilesDownload(this.documentId, await this.myservice.getToken()).subscribe((res) => {
            console.log(res);
            this.downloadBase64File(res.data, res.fileName);
        });
    }

    getFileMimeType(fileName: string): string {
        return this.myservice.getFileMimeType(fileName)
    }

    downloadBase64File(base64Data: string, fileName: string) {
        this.myservice.downloadBase64File(base64Data, fileName);
    }

    public base64ToBlob(base64Data: string, contentType: string): Blob {
        return this.myservice.base64ToBlob(base64Data, contentType);
    }

    convertBase64ToFileUrl(base64: any, mimeType: string): void {
        const blob = this.base64ToBlob(base64, mimeType);
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    }
}
